import { c as _c } from "react/compiler-runtime";
import { IconArrowUp, IconCertificateOff, IconChevronDown, IconChevronUp } from "@tabler/icons-react";
import { Fragment, useState } from "react";
import { CertificateAlert } from "@/components/domain/certificate-alert";
import { KeyValue } from "@/components/domain/key-value";
import { KeyValueGrid } from "@/components/domain/key-value-grid";
import { RelativeAgeString } from "@/components/domain/relative-age";
import { RelativeExpiryString } from "@/components/domain/relative-expiry";
import { ReportSection } from "@/components/domain/report-section";
import { ProviderLogo } from "@/components/icons/provider-logo";
import { sections } from "@/lib/constants/sections";
import type { Certificate, CertificatesResponse } from "@domainstack/types";
import { Badge } from "@domainstack/ui/badge";
import { Button } from "@domainstack/ui/button";
import { Empty, EmptyDescription, EmptyHeader, EmptyMedia, EmptyTitle } from "@domainstack/ui/empty";
import { ResponsiveTooltip, ResponsiveTooltipContent, ResponsiveTooltipTrigger } from "@domainstack/ui/responsive-tooltip";
import { cn } from "@domainstack/ui/utils";
import { formatDate, formatDateTimeUtc, toDateTimeAttr } from "@domainstack/utils/date";
function CertificateCard(t0) {
  const $ = _c(75);
  const {
    cert
  } = t0;
  let T0;
  let T1;
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  if ($[0] !== cert.altNames || $[1] !== cert.caProvider || $[2] !== cert.issuer || $[3] !== cert.subject) {
    const sans = Array.isArray(cert.altNames) ? cert.altNames.filter(n => !equalHostname(n, cert.subject)) : [];
    t6 = "relative overflow-hidden rounded-xl border bg-background/60 p-3 backdrop-blur-lg";
    T1 = KeyValueGrid;
    t4 = 2;
    let t7;
    if ($[12] !== cert.caProvider) {
      t7 = cert.caProvider?.id ? <ProviderLogo providerId={cert.caProvider.id} providerName={cert.caProvider.name} /> : undefined;
      $[12] = cert.caProvider;
      $[13] = t7;
    } else {
      t7 = $[13];
    }
    let t8;
    if ($[14] !== cert.caProvider) {
      t8 = cert.caProvider?.name ? <span className="text-[11px] text-muted-foreground">{cert.caProvider.name}</span> : undefined;
      $[14] = cert.caProvider;
      $[15] = t8;
    } else {
      t8 = $[15];
    }
    if ($[16] !== cert.issuer || $[17] !== t7 || $[18] !== t8) {
      t5 = <KeyValue label="Issuer" value={cert.issuer} leading={t7} suffix={t8} />;
      $[16] = cert.issuer;
      $[17] = t7;
      $[18] = t8;
      $[19] = t5;
    } else {
      t5 = $[19];
    }
    T0 = KeyValue;
    t1 = "Subject";
    t2 = cert.subject;
    t3 = sans.length > 0 ? <ResponsiveTooltip><ResponsiveTooltipTrigger nativeButton={false} render={<Badge variant="outline" className="gap-0 border-muted-foreground/35 px-1.5 font-mono text-[11px] text-muted-foreground/85 select-none"><span>+</span><span className="px-[1px]">{sans.length}</span></Badge>} /><ResponsiveTooltipContent className="max-w-[80vw] break-words whitespace-pre-wrap md:max-w-[40rem]">{sans.join(", ")}</ResponsiveTooltipContent></ResponsiveTooltip> : undefined;
    $[0] = cert.altNames;
    $[1] = cert.caProvider;
    $[2] = cert.issuer;
    $[3] = cert.subject;
    $[4] = T0;
    $[5] = T1;
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
    $[11] = t6;
  } else {
    T0 = $[4];
    T1 = $[5];
    t1 = $[6];
    t2 = $[7];
    t3 = $[8];
    t4 = $[9];
    t5 = $[10];
    t6 = $[11];
  }
  let t7;
  if ($[20] !== T0 || $[21] !== t1 || $[22] !== t2 || $[23] !== t3) {
    t7 = <T0 label={t1} value={t2} suffix={t3} />;
    $[20] = T0;
    $[21] = t1;
    $[22] = t2;
    $[23] = t3;
    $[24] = t7;
  } else {
    t7 = $[24];
  }
  let t8;
  if ($[25] !== cert.validFrom) {
    t8 = toDateTimeAttr(cert.validFrom);
    $[25] = cert.validFrom;
    $[26] = t8;
  } else {
    t8 = $[26];
  }
  let t9;
  if ($[27] !== cert.validFrom) {
    t9 = formatDate(cert.validFrom);
    $[27] = cert.validFrom;
    $[28] = t9;
  } else {
    t9 = $[28];
  }
  let t10;
  if ($[29] !== t8 || $[30] !== t9) {
    t10 = <time dateTime={t8} suppressHydrationWarning={true}>{t9}</time>;
    $[29] = t8;
    $[30] = t9;
    $[31] = t10;
  } else {
    t10 = $[31];
  }
  let t11;
  if ($[32] !== cert.validFrom) {
    t11 = toDateTimeAttr(cert.validFrom);
    $[32] = cert.validFrom;
    $[33] = t11;
  } else {
    t11 = $[33];
  }
  let t12;
  if ($[34] !== cert.validFrom) {
    t12 = formatDateTimeUtc(cert.validFrom);
    $[34] = cert.validFrom;
    $[35] = t12;
  } else {
    t12 = $[35];
  }
  let t13;
  if ($[36] !== t11 || $[37] !== t12) {
    t13 = <time dateTime={t11} suppressHydrationWarning={true}>{t12}</time>;
    $[36] = t11;
    $[37] = t12;
    $[38] = t13;
  } else {
    t13 = $[38];
  }
  let t14;
  if ($[39] !== cert.validFrom) {
    t14 = <span className="text-[11px] leading-none text-muted-foreground"><RelativeAgeString from={cert.validFrom} /></span>;
    $[39] = cert.validFrom;
    $[40] = t14;
  } else {
    t14 = $[40];
  }
  let t15;
  if ($[41] !== t10 || $[42] !== t13 || $[43] !== t14) {
    t15 = <KeyValue label="Valid from" value={t10} valueTooltip={t13} suffix={t14} />;
    $[41] = t10;
    $[42] = t13;
    $[43] = t14;
    $[44] = t15;
  } else {
    t15 = $[44];
  }
  let t16;
  if ($[45] !== cert.validTo) {
    t16 = toDateTimeAttr(cert.validTo);
    $[45] = cert.validTo;
    $[46] = t16;
  } else {
    t16 = $[46];
  }
  let t17;
  if ($[47] !== cert.validTo) {
    t17 = formatDate(cert.validTo);
    $[47] = cert.validTo;
    $[48] = t17;
  } else {
    t17 = $[48];
  }
  let t18;
  if ($[49] !== t16 || $[50] !== t17) {
    t18 = <time dateTime={t16} suppressHydrationWarning={true}>{t17}</time>;
    $[49] = t16;
    $[50] = t17;
    $[51] = t18;
  } else {
    t18 = $[51];
  }
  let t19;
  if ($[52] !== cert.validTo) {
    t19 = toDateTimeAttr(cert.validTo);
    $[52] = cert.validTo;
    $[53] = t19;
  } else {
    t19 = $[53];
  }
  let t20;
  if ($[54] !== cert.validTo) {
    t20 = formatDateTimeUtc(cert.validTo);
    $[54] = cert.validTo;
    $[55] = t20;
  } else {
    t20 = $[55];
  }
  let t21;
  if ($[56] !== t19 || $[57] !== t20) {
    t21 = <time dateTime={t19} suppressHydrationWarning={true}>{t20}</time>;
    $[56] = t19;
    $[57] = t20;
    $[58] = t21;
  } else {
    t21 = $[58];
  }
  let t22;
  if ($[59] !== cert.validTo) {
    t22 = <span className="text-[11px] leading-none text-muted-foreground"><RelativeExpiryString to={cert.validTo} dangerDays={7} warnDays={21} /></span>;
    $[59] = cert.validTo;
    $[60] = t22;
  } else {
    t22 = $[60];
  }
  let t23;
  if ($[61] !== t18 || $[62] !== t21 || $[63] !== t22) {
    t23 = <KeyValue label="Valid to" value={t18} valueTooltip={t21} suffix={t22} />;
    $[61] = t18;
    $[62] = t21;
    $[63] = t22;
    $[64] = t23;
  } else {
    t23 = $[64];
  }
  let t24;
  if ($[65] !== T1 || $[66] !== t15 || $[67] !== t23 || $[68] !== t4 || $[69] !== t5 || $[70] !== t7) {
    t24 = <T1 colsDesktop={t4}>{t5}{t7}{t15}{t23}</T1>;
    $[65] = T1;
    $[66] = t15;
    $[67] = t23;
    $[68] = t4;
    $[69] = t5;
    $[70] = t7;
    $[71] = t24;
  } else {
    t24 = $[71];
  }
  let t25;
  if ($[72] !== t24 || $[73] !== t6) {
    t25 = <div className={t6}>{t24}</div>;
    $[72] = t24;
    $[73] = t6;
    $[74] = t25;
  } else {
    t25 = $[74];
  }
  return t25;
}
export function CertificatesSection(t0) {
  const $ = _c(7);
  const {
    data
  } = t0;
  const [showAll, setShowAll] = useState(false);
  let t1;
  if ($[0] !== data || $[1] !== showAll) {
    const certificates = data?.certificates ?? [];
    const error = data?.error;
    const isInvalid = Boolean(data && (!data.valid || error || data.validationError));
    const firstCert = certificates.length > 0 ? certificates[0] : null;
    const remainingCerts = certificates.length > 1 ? certificates.slice(1) : [];
    let t2;
    if ($[3] !== data?.validationError || $[4] !== error || $[5] !== isInvalid) {
      t2 = isInvalid ? <div className="mb-4"><CertificateAlert validationError={data?.validationError} error={error} /></div> : null;
      $[3] = data?.validationError;
      $[4] = error;
      $[5] = isInvalid;
      $[6] = t2;
    } else {
      t2 = $[6];
    }
    t1 = <ReportSection {...sections.certificates}>{t2}{firstCert ? <><CertificateCard cert={firstCert} />{remainingCerts.length > 0 && !showAll && <div className="mt-4 flex justify-center"><Button variant="ghost" size="sm" aria-expanded={false} onClick={() => setShowAll(true)} className="text-[13px]"><IconChevronDown className="size-4" aria-hidden={true} /><span>Show Chain</span></Button></div>}{remainingCerts.length > 0 && <div className={cn("grid overflow-hidden transition-[grid-template-rows,opacity] duration-200 ease-out motion-reduce:transition-none", showAll ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0")} inert={!showAll} aria-hidden={!showAll}><div className="min-h-0 overflow-hidden"><div className="my-3 flex justify-center"><IconArrowUp className="size-4 text-muted-foreground/60" aria-hidden={true} /></div>{remainingCerts.map((cert, index) => <Fragment key={`cert-${cert.subject}-${cert.validFrom}-${cert.validTo}`}><CertificateCard cert={cert} />{index < remainingCerts.length - 1 && <div className="my-3 flex justify-center"><IconArrowUp className="size-4 text-muted-foreground/60" aria-hidden={true} /></div>}</Fragment>)}<div className="mt-4 flex justify-center"><Button variant="ghost" size="sm" onClick={() => setShowAll(false)} className="text-[13px]" aria-expanded={true}><IconChevronUp className="size-4" aria-hidden={true} /><span>Hide Chain</span></Button></div></div></div>}</> : <Empty className="border border-dashed"><EmptyHeader><EmptyMedia variant="icon"><IconCertificateOff /></EmptyMedia><EmptyTitle>No certificates found</EmptyTitle><EmptyDescription>We couldn't retrieve a TLS certificate chain for this site. Ensure the domain resolves and serves HTTPS on port 443.</EmptyDescription></EmptyHeader></Empty>}</ReportSection>;
    $[0] = data;
    $[1] = showAll;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
}
export function equalHostname(a: string, b: string): boolean {
  return a.trim().toLowerCase() === b.trim().toLowerCase();
}